angular.module('workflow.app')
  .factory 'heimdallClassifications', () ->
    classifications = {
      "Special Interest Entity (SIE)": "SIE"
      "Special Interest Person (SIP)": "SIP"
      "Relative or Close Associate (RCA)": "RCA"
      "Politically Exposed Person (PEP)": "PEP"
      "Enhanced Country Risk": "ECR"
      "Other Official Lists": "OOL"
      "Other Exclusion Lists": "OEL"
      "Sanctions Lists": "SAN"
    }

    return {
      exists: (c) ->
        return classifications[c]?
      get: (c) ->
        return classifications[c] or ""
      all: ->
        return classifications
    }
